export function getGlobalObject() {
    return (typeof window === 'object' ? window : {});
}
